module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.lAction === 'view' || _vm.showResolve) ? _c('v-tabs', {
    attrs: {
      "flat": "",
      "color": "primary",
      "dark": "",
      "grow": "",
      "height": "40",
      "fixed-tabs": ""
    },
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, _vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab', {
      key: n,
      attrs: {
        "href": ("#tab-" + n)
      }
    }, [_c('v-badge', {
      attrs: {
        "overlap": ""
      },
      scopedSlots: _vm._u([(_vm.enabledFilter['tab-' + n]) ? {
        key: "badge",
        fn: function() {
          return [_c('v-icon', {
            staticClass: "caption"
          }, [_vm._v("filter_list")])]
        },
        proxy: true
      } : null], null, true)
    }, [_vm._v(" "), _c('div', {
      staticClass: "pa-2"
    }, [_vm._v(_vm._s(tabitem + ' (' + _vm.stats[tabitem] + ')'))])])], 1)
  }), 1) : _vm._e(), _vm._v(" "), _c('v-container', {
    staticClass: "pa-1",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.lAction === 'view' || _vm.showResolve) ? _c('v-tabs-items', {
    model: {
      value: (_vm.tab),
      callback: function($$v) {
        _vm.tab = $$v
      },
      expression: "tab"
    }
  }, [_vm._l((_vm.tabitems), function(tabitem, n) {
    return _c('v-tab-item', {
      key: n,
      attrs: {
        "value": ("tab-" + n)
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [(_vm.comps[tabitem].length === 0 && !_vm.load) ? _c('v-card-text', {
      staticClass: "info--text text-xs-center"
    }, [_vm._v("No complaints!")]) : _vm._e(), _vm._v(" "), _c('v-expansion-panel', {
      attrs: {
        "value": _vm.selRec
      }
    }, _vm._l((_vm.comps[tabitem]), function(comp, i) {
      return _c('v-expansion-panel-content', {
        key: i,
        on: {
          "input": function($event) {
            _vm.loadComments(comp), _vm.loadDetail(comp), _vm.loadCompAttachment(comp)
          }
        }
      }, [_c('div', {
        attrs: {
          "slot": "header"
        },
        slot: "header"
      }, [_c('v-layout', {
        staticClass: "pb-4",
        attrs: {
          "row": ""
        }
      }, [_c('v-flex', {
        staticClass: "caption white--text",
        attrs: {
          "xs12": ""
        }
      }, [_c('div', {
        staticClass: "pa-1 grey lighten-4 caption black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "left": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_cat + ' (Complaint #' + comp.comp_id + ')') + "\n                        "), (comp.is_comm_comp) ? _c('v-icon', [_vm._v("location_city")]) : _c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), (comp.comp_status === 'New' || comp.comp_status === 'Reopened') ? _c('div', {
        staticClass: "pa-1 red lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_status) + "\n                      ")]) : (comp.comp_status === 'Assigned') ? _c('div', {
        staticClass: "pa-1 blue lighten-2",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_status) + "\n                      ")]) : (comp.comp_status === 'In Progress') ? _c('div', {
        staticClass: "pa-1 yellow black--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_status) + "\n                      ")]) : (comp.comp_status.includes('Resolved')) ? _c('div', {
        staticClass: "pa-1 success",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_status) + "\n                      ")]) : _c('div', {
        staticClass: "pa-1 accent white--text",
        staticStyle: {
          "position": "absolute",
          "top": "5px",
          "right": "0px"
        }
      }, [_vm._v("\n                        " + _vm._s(comp.comp_status) + "\n                      ")])])], 1), _vm._v(" "), _c('v-layout', {
        attrs: {
          "row": "",
          "wrap": ""
        }
      }, [_c('v-flex', {
        attrs: {
          "xs3": "",
          "sm2": "",
          "md1": ""
        }
      }, [_c('v-avatar', {
        staticClass: "pt-4",
        attrs: {
          "slot": "activator",
          "size": "48px"
        },
        slot: "activator"
      }, [_c('img', {
        attrs: {
          "src": _vm.config.STATIC_FILES_DIR + comp.avatar_url
        }
      })])], 1), _vm._v(" "), _c('v-flex', {
        class: _vm.$vuetify.breakpoint.sm ? 'ml-2' : '',
        attrs: {
          "xs9": "",
          "sm9": "",
          "md11": ""
        }
      }, [_c('div', {
        staticClass: "subheading"
      }, [_vm._v(_vm._s(comp.comp_title) + "\n                        "), (comp.tagged_by === _vm.curUserId) ? _c('span', {
        staticStyle: {
          "position": "absolute",
          "top": "35px",
          "right": "25px"
        }
      }, [_c('v-icon', {
        attrs: {
          "color": "yellow"
        }
      }, [_vm._v("star_border")])], 1) : _vm._e()]), _vm._v(" "), _c('div', [_c('span', {
        staticClass: "primary--text"
      }, [_vm._v(" " + _vm._s(comp.cust_name + ' (' + (comp.is_behalf ? (comp.role_name + (comp.block_nm ? (' on behalf of ' + comp.block_nm + ',' + comp.unit_no) : '')) : (comp.block_nm + ',' + comp.unit_no)) + ')') + " ")]), _vm._v(" "), _c('span', {
        staticClass: "grey--text"
      }, [_vm._v(" " + _vm._s(' - ' + comp.comp_text.substring(0, 35) + '...') + " ")])]), _vm._v(" "), _c('div', {
        staticClass: "caption grey--text mt-2"
      }, [_c('span', {
        staticClass: "mr-2"
      }, [_vm._v(_vm._s(_vm.handy.formatDateTime(comp.comp_dt)))])]), _vm._v(" "), _c('div', {
        staticClass: "caption info--text"
      }, [_c('v-tooltip', {
        attrs: {
          "top": "",
          "disabled": comp.agreed === 0
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('span', _vm._g({
              staticClass: "mr-2",
              on: {
                "mouseover": function($event) {
                  return _vm.loadListOfPeopleAgreed(comp)
                }
              }
            }, on), [_vm._v(_vm._s(comp.agreed) + " Agreed")])]
          }
        }], null, true)
      }, [_vm._v(" "), _vm._l((_vm.totalAgreed), function(agreed, i) {
        return _c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(agreed.cust_name + ' ' + '(' + (agreed.block_nm ? (agreed.block_nm + ',' + agreed.unit_no) : agreed.role_name) + ') ')), _c('br')])
      })], 2), _vm._v(" "), _c('v-tooltip', {
        attrs: {
          "top": "",
          "disabled": comp.comments === 0
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('span', _vm._g({
              staticClass: "mr-2",
              on: {
                "mouseover": function($event) {
                  return _vm.loadListOfPeopleCommentedComp(comp)
                }
              }
            }, on), [_vm._v(_vm._s(comp.comments) + " Comments")])]
          }
        }], null, true)
      }, [_vm._v(" "), _vm._l((_vm.totalComment), function(comment, i) {
        return _c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(comment.cust_name + ' ' + '(' + (comment.block_nm ? (comment.block_nm + ',' + comment.unit_no) : comment.role_name) + ') ')), _c('br')])
      })], 2), _vm._v(" "), _c('v-tooltip', {
        attrs: {
          "top": "",
          "disabled": comp.tags === 0
        },
        scopedSlots: _vm._u([{
          key: "activator",
          fn: function(ref) {
            var on = ref.on;

            return [_c('span', _vm._g({
              on: {
                "mouseover": function($event) {
                  return _vm.loadListOfPeoplePinnedComp(comp)
                }
              }
            }, on), [_vm._v(_vm._s(comp.tags) + " Pinned")])]
          }
        }], null, true)
      }, [_vm._v(" "), _vm._l((_vm.totalPinned), function(pinned, i) {
        return _c('span', {
          staticClass: "caption"
        }, [_vm._v(_vm._s(pinned.cust_name + ' ' + '(' + (pinned.block_nm ? (pinned.block_nm + ',' + pinned.unit_no) : pinned.role_name) + ') ')), _c('br')])
      })], 2)], 1), _vm._v(" "), (comp.comp_status.includes('Resolved')) ? _c('div', {
        on: {
          "click": function($event) {
            return _vm.loadCompRatings(comp)
          }
        }
      }, [_c('v-rating', {
        attrs: {
          "size": "20",
          "color": "accent",
          "background-color": "grey",
          "dense": "",
          "readonly": !(comp.user_can_rate && comp.user_can_rate.split(',').map(function (rec) { return parseInt(rec); }).indexOf(_vm.config.USER_ID) > -1)
        },
        on: {
          "input": function($event) {
            return _vm.saveRatings(comp, true)
          }
        },
        model: {
          value: (comp.overall),
          callback: function($$v) {
            _vm.$set(comp, "overall", $$v)
          },
          expression: "comp.overall"
        }
      })], 1) : _vm._e()])], 1)], 1), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": "",
          "id": 'comp_' + n + '_' + i
        }
      }, [_c('v-card-text', {
        staticClass: "pa-2"
      }, [_c('div', {
        staticClass: "pb-1"
      }, [_vm._v(_vm._s(comp.comp_text))]), _vm._v(" "), _c('v-card', {
        attrs: {
          "flat": ""
        }
      }, [(comp.files && comp.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('v-card-text', {
        staticClass: "pt-0 pr-0 pl-0 pb-2"
      }, [_c('div', {
        directives: [{
          name: "viewer",
          rawName: "v-viewer",
          value: (_vm.options),
          expression: "options"
        }],
        staticClass: "clearfix"
      }, [_vm._l((comp.files.filter(function (rec) { return rec.source_type === 'Complaint'; })), function(file, index) {
        return [_c('img', {
          key: index,
          staticClass: "ma-1",
          staticStyle: {
            "display": "inline-block",
            "cursor": "pointer"
          },
          attrs: {
            "width": "80px",
            "src": _vm.config.FM_SPACES_BASE_URL + file.file_url,
            "data-source": _vm.config.FM_SPACES_BASE_URL + file.file_url
          }
        })]
      })], 2)]) : _vm._e()], 1), _vm._v(" "), _vm._l((comp.comments_list), function(comment, c) {
        return _c('v-card', {
          key: c,
          class: (comment.comment_id ? 'grey ' : '') + 'lighten-4 mb-1',
          style: (!comment.comment_id ? 'border: 1px solid lightgray' : ''),
          attrs: {
            "flat": ""
          }
        }, [_c('v-card-text', {
          staticClass: "pt-2 pr-2 pb-0 pl-2"
        }, [_c('v-layout', {
          attrs: {
            "row": ""
          }
        }, [_c('v-flex', {
          staticClass: "pl-2 pb-2",
          attrs: {
            "xs2": "",
            "sm1": ""
          }
        }, [_c('v-avatar', {
          attrs: {
            "slot": "activator",
            "size": "36px"
          },
          slot: "activator"
        }, [_c('img', {
          attrs: {
            "src": _vm.config.STATIC_FILES_DIR + comment.avatar_url
          }
        })])], 1), _vm._v(" "), _c('v-flex', {
          staticClass: "pl-2",
          attrs: {
            "xs12": "",
            "sm12": ""
          }
        }, [(comment.comment_status === 'Recalled' || comment.comment_status === 'Disabled') ? _c('div', [_c('span', {
          staticClass: "primary--text"
        }, [_vm._v(" " + _vm._s(comment.cust_name) + " ")]), _vm._v(" "), (comment.comment_status === 'Recalled') ? _c('span', {
          staticClass: "warning--text caption"
        }, [_vm._v(" - Recalled comment")]) : _c('span', {
          staticClass: "warning--text caption"
        }, [_vm._v(" - Disabled by MC")])]) : _c('div', [_c('span', {
          class: comment.comment_id ? 'primary--text' : 'grey--text'
        }, [_vm._v(" " + _vm._s(comment.comment_id ? 'Commented by' : comment.comment_status + ' by') + " " + _vm._s(comment.cust_name) + " " + _vm._s(comment.comment_status === 'Assigned' && comment.assigned_to ? ' to ' + comment.assigned_to : '') + " ")]), _vm._v(" "), _c('span', {
          staticClass: "caption grey--text",
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v(_vm._s(_vm.handy.formatDateTime(comment.comment_dt) + (comment.edited_dt ? '.' : '')) + "\n                                "), (comment.edited_dt) ? _c('span', {
          staticClass: "black--text"
        }, [_vm._v("Edited.")]) : _vm._e(), _vm._v(" "), (comment.comment_id) ? _c('span', {
          staticClass: "mr-2 caption info--text",
          staticStyle: {
            "float": "right"
          }
        }, [_vm._v("  " + _vm._s(comment.agreed) + " Agreed")]) : _vm._e()]), _vm._v(" "), _c('div', [_vm._v(" " + _vm._s(comment.comment_text) + " ")]), _vm._v(" "), (comment.comment_status === 'Out Of Scope' && comp.comp_status === 'Out Of Scope') ? _c('v-card', {
          staticClass: "blue lighten-4 mt-2 mb-2"
        }, [_c('v-card-text', {
          staticClass: "pb-0"
        }, [_vm._v("\n                                  Sorry to inform you that the problem stated in complaint is out of scope of maintenance contract made with the association. If you wish, you can avail our on-call service at nominal rate or you can get it done by any other vendor of your choice.\n                                ")]), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.loadRateCard(), _vm.showRateCard = true
            }
          }
        }, [_vm._v("Rate card")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.bookOnCallService(comp)
            }
          }
        }, [_vm._v("Book on-call service")])], 1)], 1) : _vm._e(), _vm._v(" "), (comment.comment_status === 'On-call Service Booked' && comp.comp_status === 'On-call Service Booked') ? _c('v-card', {
          staticClass: "mt-2 mb-2"
        }, [_c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              _vm.loadRateCard(), _vm.showRateCard = true
            }
          }
        }, [_vm._v("Rate card")]), _vm._v(" "), _c('v-btn', {
          attrs: {
            "small": ""
          },
          on: {
            "click": function($event) {
              return _vm.bookOnCallService(comp)
            }
          }
        }, [_vm._v("Cancel on-call booking")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), (comment.ready_for_disable) ? _c('div', [(comment.comment_status !== 'Disabled') ? _c('span', {
          staticStyle: {
            "float": "right"
          },
          attrs: {
            "color": "grey"
          }
        }, [_c('v-btn', {
          staticClass: "ma-0",
          attrs: {
            "icon": ""
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.cancelDisableComment(comment)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("close")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-text-field', {
          attrs: {
            "hide-details": "",
            "label": "Disabled reason",
            "counter": "100"
          },
          model: {
            value: (comment.disabled_reason),
            callback: function($$v) {
              _vm.$set(comment, "disabled_reason", $$v)
            },
            expression: "comment.disabled_reason"
          }
        })], 1) : _vm._e(), _vm._v(" "), ((comment.user_id === _vm.curUserId || _vm.config.IS_MC_MEMBER || _vm.config.IS_ADMIN) && comment.comment_status === 'Disabled') ? _c('div', {
          staticClass: "info white--text pa-1"
        }, [_c('span', {
          staticClass: "yellow--text"
        }, [_vm._v("Disabled reason (only visible to you)"), _c('br')]), _vm._v(" "), _c('span', [_vm._v(_vm._s(comment.disabled_reason))])]) : _vm._e()])], 1), _vm._v(" "), _c('v-layout', {
          attrs: {
            "row": "",
            "wrap": ""
          }
        }, [(comp.files && comp.files.filter(function (rec) { return rec.is_selected; }).length > 0) ? _c('span', [_c('div', {
          directives: [{
            name: "viewer",
            rawName: "v-viewer",
            value: (_vm.options),
            expression: "options"
          }],
          staticClass: "clearfix"
        }, [_vm._l((comp.files.filter(function (rec) { return (rec.source_type === 'Comment' && rec.source_ref_id === comment.comment_id) || (rec.source_type === 'Resolve' && rec.source_ref_id === comment.comp_det_id); })), function(file, index) {
          return [_c('img', {
            key: index,
            staticClass: "ma-1",
            staticStyle: {
              "display": "inline-block",
              "cursor": "pointer"
            },
            attrs: {
              "width": "80px",
              "src": _vm.config.FM_SPACES_BASE_URL + file.file_url,
              "data-source": _vm.config.FM_SPACES_BASE_URL + file.file_url
            }
          })]
        })], 2)]) : _vm._e()])], 1), _vm._v(" "), (comment.comment_status === 'Active') ? _c('v-card-actions', {
          staticClass: "ma-0 pa-0"
        }, [_c('v-spacer'), _vm._v(" "), (comment.user_id === _vm.curUserId) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.prepareEditComment(comp, comment)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (comment.user_id === _vm.curUserId || _vm.config.IS_MC_MEMBER || _vm.config.IS_ADMIN) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.recallComment(comment, comp)
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": "",
            "color": comment.ready_for_disable ? 'accent' : ''
          }
        }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (comment.agreed_by != _vm.curUserId) ? _c('v-btn', {
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.agreeComment(comment, 'agree')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("thumb_up")])], 1) : _c('v-btn', {
          staticClass: "primary--text",
          attrs: {
            "icon": ""
          },
          nativeOn: {
            "click": function($event) {
              return _vm.agreeComment(comment, 'disagree')
            }
          }
        }, [_c('v-icon', {
          attrs: {
            "small": ""
          }
        }, [_vm._v("thumb_up")])], 1)], 1) : _vm._e()], 1)
      }), _vm._v(" "), (comp.ready_for_comment) ? _c('div', [_c('div', [_c('span', {
        staticStyle: {
          "float": "right"
        },
        attrs: {
          "color": "grey"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "icon": "",
          "small": ""
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.cancelComment(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("clear")])], 1)], 1), _vm._v(" "), _c('v-text-field', {
        attrs: {
          "hide-details": "",
          "textarea": "",
          "placeholder": "Your comment",
          "rows": "2"
        },
        model: {
          value: (comp.comment.comment_text),
          callback: function($$v) {
            _vm.$set(comp.comment, "comment_text", $$v)
          },
          expression: "comp.comment.comment_text"
        }
      })], 1), _vm._v(" "), _c('div', [_c('input', {
        staticStyle: {
          "display": "none"
        },
        attrs: {
          "type": "file",
          "id": "commentFileInput",
          "accept": "image/*",
          "multiple": ""
        },
        on: {
          "change": function($event) {
            return _vm.loadFilesFromFileBrowser(comp.comment)
          }
        }
      }), _vm._v(" "), _c('v-btn', {
        attrs: {
          "icon": ""
        },
        on: {
          "click": _vm.pickFile
        }
      }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (comp.comment.files && comp.comment.files.filter(function (rec) { return rec.is_selected && rec.source_type === 'Comment'; }).length > 0) ? _c('span', _vm._l((comp.comment.files.filter(function (rec) { return rec.source_type === 'Comment' && rec.source_ref_id === comp.comment.comment_id; })), function(file, index) {
        return _c('span', {
          key: index
        }, [_c('v-chip', {
          attrs: {
            "close": ""
          },
          on: {
            "input": function($event) {
              return _vm.$forceUpdate()
            }
          },
          model: {
            value: (file.is_selected),
            callback: function($$v) {
              _vm.$set(file, "is_selected", $$v)
            },
            expression: "file.is_selected"
          }
        }, [_vm._v(_vm._s(file.file_name))])], 1)
      }), 0) : _c('span', [_vm._v("Attachment if any"), _c('span', {
        staticClass: "caption"
      }, [_vm._v(" (images only, upto 20MB)")])])], 1), _vm._v(" "), _c('div', {
        staticStyle: {
          "float": "right"
        }
      }, [_c('v-btn', {
        staticClass: "ma-0",
        attrs: {
          "flat": "",
          "color": "accent",
          "disabled": _vm.beingSaved
        },
        on: {
          "click": function($event) {
            $event.stopPropagation();
            return _vm.postComment(comp)
          }
        }
      }, [_vm._v("Comment")])], 1)]) : _vm._e()], 2), _vm._v(" "), (!comp.ready_for_comment) ? _c('div', [(comp.user_id === _vm.curUserId) ? _c('v-card-actions', {
        staticClass: "pt-0"
      }, [_c('v-spacer'), _vm._v(" "), (comp.comp_status === 'New') ? _c('v-btn', {
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareUpdate(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("edit")])], 1) : _vm._e(), _vm._v(" "), (comp.comp_status === 'New') ? _c('v-btn', {
        attrs: {
          "icon": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.deleteComp(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("delete")])], 1) : _vm._e(), _vm._v(" "), (comp.commented_by != _vm.curUserId) ? _c('v-btn', {
        staticClass: "pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1) : _c('v-btn', {
        staticClass: "primary--text pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1), _vm._v(" "), (_vm.config.IS_USER_EMPOWERED && !comp.comp_status.includes('Resolved') && comp.comp_status !== 'Rejected' && comp.comp_status !== 'Out Of Scope') ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": "",
          "color": "accent"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareResolve(comp)
          }
        }
      }, [_vm._v("Update / Resolve")]) : _vm._e(), _vm._v(" "), (comp.comp_status.includes('Resolved') || comp.comp_status === 'Rejected' || comp.comp_status === 'Out Of Scope') ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": "",
          "disabled": _vm.beingSaved
        },
        nativeOn: {
          "click": function($event) {
            return _vm.reopenComp(comp)
          }
        }
      }, [_vm._v("Reopen")]) : _vm._e()], 1) : (tabitem === 'all open') ? _c('v-card-actions', {
        staticClass: "pt-0"
      }, [_c('v-spacer'), _vm._v(" "), (comp.agreed_by != _vm.curUserId) ? _c('v-btn', {
        staticClass: "pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.agreeComp(comp, 'agree')
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("thumb_up")])], 1) : _c('v-btn', {
        staticClass: "primary--text pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.agreeComp(comp, 'disagree')
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("thumb_up")])], 1), _vm._v(" "), (comp.commented_by != _vm.curUserId) ? _c('v-btn', {
        staticClass: "pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1) : _c('v-btn', {
        staticClass: "primary--text pl-3 pr-3",
        attrs: {
          "icon": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareComment(comp)
          }
        }
      }, [_c('v-icon', {
        attrs: {
          "small": ""
        }
      }, [_vm._v("comment")])], 1), _vm._v(" "), (comp.tagged_by != _vm.curUserId) ? _c('v-btn', {
        staticClass: "ma-0 pa-0",
        attrs: {
          "flat": "",
          "small": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.tagComp(comp, 'tag')
          }
        }
      }, [_vm._v("Pin")]) : _c('v-btn', {
        staticClass: "primary--text ma-0",
        attrs: {
          "small": "",
          "flat": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.tagComp(comp, 'untag')
          }
        }
      }, [_vm._v("Pinned")]), _vm._v(" "), (_vm.config.IS_USER_EMPOWERED) ? _c('v-btn', {
        attrs: {
          "small": "",
          "flat": "",
          "color": "accent"
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareResolve(comp)
          }
        }
      }, [_vm._v("Update / Resolve")]) : _vm._e()], 1) : (tabitem !== 'all closed') ? _c('v-card-actions', {
        staticClass: "pt-0"
      }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
        attrs: {
          "small": "",
          "flat": ""
        },
        nativeOn: {
          "click": function($event) {
            return _vm.prepareResolve(comp)
          }
        }
      }, [_vm._v("Update / Resolve")])], 1) : _vm._e()], 1) : _vm._e()], 1)], 1)
    }), 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), (tabitem === 'mine') ? _c('infinite-loading', {
      attrs: {
        "spinner": "spiral"
      },
      on: {
        "infinite": _vm.loadMoreMine
      }
    }, [_c('span', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })]) : (tabitem === 'all open') ? _c('infinite-loading', {
      attrs: {
        "spinner": "spiral"
      },
      on: {
        "infinite": _vm.loadMoreOpen
      }
    }, [_c('span', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })]) : _c('infinite-loading', {
      attrs: {
        "spinner": "spiral"
      },
      on: {
        "infinite": _vm.loadMoreClosed
      }
    }, [_c('span', {
      attrs: {
        "slot": "spinner"
      },
      slot: "spinner"
    }), _vm._v(" "), _c('span', {
      attrs: {
        "slot": "no-more"
      },
      slot: "no-more"
    })])], 1)], 1)
  }), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; left:15px;' : 'bottom:15px; left:320px;')),
    attrs: {
      "small": "",
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareFilter($event)
      }
    }
  }, [_c('v-badge', {
    attrs: {
      "overlap": "",
      "color": "info"
    },
    scopedSlots: _vm._u([(_vm.enabledFilter[this.tab]) ? {
      key: "badge",
      fn: function() {
        return [_c('v-icon', {
          staticClass: "caption"
        }, [_vm._v("done")])]
      },
      proxy: true
    } : null], null, true)
  }, [_vm._v(" "), _c('v-icon', {
    staticClass: "pa-2"
  }, [_vm._v("filter_list")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    style: ('position:fixed; ' + (_vm.$vuetify.breakpoint.smAndDown ? 'bottom:15px; right:15px;' : 'bottom:15px; right:15px;')),
    attrs: {
      "dark": "",
      "fab": "",
      "fixed": "",
      "color": "accent"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.prepareCreate($event)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1), _vm._v(" "), _c('v-bottom-sheet', {
    staticClass: "caption",
    attrs: {
      "inset": "",
      "max-width": "500px"
    },
    model: {
      value: (_vm.showFilter),
      callback: function($$v) {
        _vm.showFilter = $$v
      },
      expression: "showFilter"
    }
  }, [_c('v-card', [_c('v-card-text', [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text"
  }, [_vm._v("Filter by attributes")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Complaint No",
      "hide-details": "",
      "maxlength": "11"
    },
    model: {
      value: (_vm.filterList[_vm.tab].comp_id),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "comp_id", $$v)
      },
      expression: "filterList[tab].comp_id"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.cats,
      "label": "Category",
      "item-text": "comp_cat",
      "item-value": "comp_cat_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "multiple": "",
      "return-object": ""
    },
    on: {
      "input": function($event) {
        return _vm.filterCompCatList(_vm.filterList[_vm.tab])
      }
    },
    model: {
      value: (_vm.filterList[_vm.tab].comp_cat_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "comp_cat_list", $$v)
      },
      expression: "filterList[tab].comp_cat_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": ['Personal', 'Community'],
      "label": "Type",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].comp_type_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "comp_type_list", $$v)
      },
      expression: "filterList[tab].comp_type_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Severity",
      "items": ['Critical', 'Normal', 'Major'],
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].severity_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "severity_list", $$v)
      },
      expression: "filterList[tab].severity_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Status",
      "items": _vm.statusList,
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].comp_status_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "comp_status_list", $$v)
      },
      expression: "filterList[tab].comp_status_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by people")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Created by",
      "items": _vm.mcList,
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].created_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "created_user_pair_list", $$v)
      },
      expression: "filterList[tab].created_user_pair_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "items": _vm.mcList,
      "label": "Assigned to",
      "item-text": "user_name",
      "item-value": "user_id",
      "hide-details": "",
      "small-chips": "",
      "clearable": "",
      "dense": "",
      "multiple": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].assigned_user_pair_list),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "assigned_user_pair_list", $$v)
      },
      expression: "filterList[tab].assigned_user_pair_list"
    }
  })], 1), _vm._v(" "), (_vm.config.USER_HAS_MORE_UNITS || _vm.config.IS_USER_EMPOWERED) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "label": "Unit",
      "items": _vm.config.USER_HAS_MORE_UNITS ? _vm.config.UNITS : _vm.unitList,
      "item-text": "block_and_unit",
      "item-value": "unit_id",
      "rules": _vm.config.IS_OTHER_USER ? [] : [_vm.rules.required],
      "dense": "",
      "clearable": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.filterList[_vm.tab].unit_id),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "unit_id", $$v)
      },
      expression: "filterList[tab].unit_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "caption primary--text pt-3"
  }, [_vm._v("Filter by date")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgFromDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterList[_vm.tab].from_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterList[_vm.tab], "from_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterList[_vm.tab], "from_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgFromDate),
      callback: function($$v) {
        _vm.dlgFromDate = $$v
      },
      expression: "dlgFromDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Logged date from",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterList[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "from_dt", $$v)
      },
      expression: "filterList[tab].from_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterList[_vm.tab].from_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "from_dt", $$v)
      },
      expression: "filterList[tab].from_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgFromDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgFromDate.save(_vm.filterList[_vm.tab].from_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "dlgToDate",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.filterList[_vm.tab].to_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.filterList[_vm.tab], "to_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.filterList[_vm.tab], "to_dt", $event)
      }
    },
    model: {
      value: (_vm.dlgToDate),
      callback: function($$v) {
        _vm.dlgToDate = $$v
      },
      expression: "dlgToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Logged date to",
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.filterList[_vm.tab].to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "to_dt", $$v)
      },
      expression: "filterList[tab].to_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1"
    },
    model: {
      value: (_vm.filterList[_vm.tab].to_dt),
      callback: function($$v) {
        _vm.$set(_vm.filterList[_vm.tab], "to_dt", $$v)
      },
      expression: "filterList[tab].to_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dlgToDate = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.dlgToDate.save(_vm.filterList[_vm.tab].to_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.showFilter = false
      }
    }
  }, [_vm._v("Close")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("Clear all")]), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": _vm.applyFilter
    }
  }, [_vm._v("Apply")])], 1)], 1)], 1)], 2) : _vm._e(), _vm._v(" "), (_vm.lAction === 'create' || _vm.lAction === 'update') ? _c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "fluid": "",
      "full-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "mx-auto": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-2"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "To",
      "items": _vm.tos,
      "item-value": "value",
      "item-text": "text",
      "rules": [_vm.rules.required],
      "chips": "",
      "multiple": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.comp_to_list),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_to_list", $$v)
      },
      expression: "lComp.comp_to_list"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-3 subheading",
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('span', [_vm._v("Is it affecting community?")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-switch', {
    attrs: {
      "label": _vm.lComp.is_comm_comp ? 'Yes' : 'No',
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.is_comm_comp),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "is_comm_comp", $$v)
      },
      expression: "lComp.is_comm_comp"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-1 subheading",
    attrs: {
      "xs8": "",
      "sm9": ""
    }
  }, [_c('span', [_vm._v("Is it critical?")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": "",
      "sm3": ""
    }
  }, [_c('v-switch', {
    staticClass: "mt-0",
    attrs: {
      "label": _vm.lComp.is_critical ? 'Yes' : 'No',
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.is_critical),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "is_critical", $$v)
      },
      expression: "lComp.is_critical"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("Be reasonable, pls check this only if it needs to be attended immediately")])]), _vm._v(" "), (_vm.config.USER_HAS_MORE_UNITS || _vm.config.IS_OTHER_USER) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Unit",
      "items": _vm.config.USER_HAS_MORE_UNITS ? _vm.config.UNITS : _vm.unitList,
      "item-text": "block_and_unit",
      "item-value": "unit_id",
      "rules": _vm.config.IS_OTHER_USER && _vm.lComp.is_comm_comp ? [] : [_vm.rules.required],
      "hint": 'Choose on behalf of which unit the complaint is raised' + (_vm.config.IS_OTHER_USER ? ' or leave it empty for common area complaints' : ''),
      "persistent-hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.lComp.unit_id),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "unit_id", $$v)
      },
      expression: "lComp.unit_id"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Category",
      "items": _vm.cats,
      "item-text": "comp_cat",
      "item-value": "comp_cat_id",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    on: {
      "input": _vm.findCat
    },
    model: {
      value: (_vm.lComp.comp_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_cat_pair", $$v)
      },
      expression: "lComp.comp_cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "mt-2",
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    ref: "title",
    attrs: {
      "label": "Complaint title",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "maxlength": "100"
    },
    model: {
      value: (_vm.lComp.comp_title),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_title", $$v)
      },
      expression: "lComp.comp_title"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    staticClass: "mt-2",
    attrs: {
      "label": "Complaint description",
      "rules": [_vm.rules.required],
      "hide-details": "",
      "rows": "4",
      "maxlength": "1000"
    },
    model: {
      value: (_vm.lComp.comp_text),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_text", $$v)
      },
      expression: "lComp.comp_text"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "prefAttendDt",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lComp.pref_attend_dt
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lComp, "pref_attend_dt", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lComp, "pref_attend_dt", $event)
      }
    },
    model: {
      value: (_vm.prefAttendDt),
      callback: function($$v) {
        _vm.prefAttendDt = $$v
      },
      expression: "prefAttendDt"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$vuetify.breakpoint.smAndUp ? 'Pref. date to attend' : 'Pref. date',
      "append-icon": "event",
      "readonly": "",
      "clearable": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lComp.pref_attend_dt),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "pref_attend_dt", $$v)
      },
      expression: "lComp.pref_attend_dt"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "scrollable": "",
      "first-day-of-week": "1",
      "min": _vm.today
    },
    model: {
      value: (_vm.lComp.pref_attend_dt),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "pref_attend_dt", $$v)
      },
      expression: "lComp.pref_attend_dt"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.prefAttendDt = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.prefAttendDt.save(_vm.lComp.pref_attend_dt)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-dialog', {
    ref: "prefAttendTime",
    attrs: {
      "persistent": "",
      "lazy": "",
      "max-width": "290px",
      "return-value": _vm.lComp.pref_attend_time
    },
    on: {
      "update:returnValue": function($event) {
        return _vm.$set(_vm.lComp, "pref_attend_time", $event)
      },
      "update:return-value": function($event) {
        return _vm.$set(_vm.lComp, "pref_attend_time", $event)
      }
    },
    model: {
      value: (_vm.prefAttendTime),
      callback: function($$v) {
        _vm.prefAttendTime = $$v
      },
      expression: "prefAttendTime"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": _vm.$vuetify.breakpoint.smAndUp ? 'Pref. time to attend' : 'Pref. time',
      "append-icon": "access_time",
      "persistent-hint": "",
      "clearable": "",
      "readonly": "",
      "hide-details": ""
    },
    slot: "activator",
    model: {
      value: (_vm.lComp.pref_attend_time),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "pref_attend_time", $$v)
      },
      expression: "lComp.pref_attend_time"
    }
  }), _vm._v(" "), _c('v-time-picker', {
    model: {
      value: (_vm.lComp.pref_attend_time),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "pref_attend_time", $$v)
      },
      expression: "lComp.pref_attend_time"
    }
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.prefAttendTime = false
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "color": "accent"
    },
    on: {
      "click": function($event) {
        return _vm.$refs.prefAttendTime.save(_vm.lComp.pref_attend_time)
      }
    }
  }, [_vm._v("OK")])], 1)], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("This is optional. if provided, technicians will try to attend around the preferred time based on the availability")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "fileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lComp)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lComp.files && _vm.lComp.files.filter(function (rec) { return rec.is_selected && rec.source_type === 'Complaint'; }).length > 0) ? _c('span', _vm._l((_vm.lComp.files.filter(function (rec) { return rec.source_type === 'Complaint'; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', {
    staticClass: "caption"
  }, [_vm._v("Attachment if any (images only, upto 20MB)")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChanges($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Log")])], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": ""
    },
    model: {
      value: (_vm.showResolve),
      callback: function($$v) {
        _vm.showResolve = $$v
      },
      expression: "showResolve"
    }
  }, [_c('v-form', {
    ref: "lForm",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.saveChanges()
      }
    }
  }, [_c('v-card', {
    attrs: {
      "scrollable": ""
    }
  }, [_c('v-card-title', {
    staticClass: "title pb-0"
  }, [_vm._v("\n        Update/Resolve Complaint\n      ")]), _vm._v(" "), _c('v-card-text', {
    staticClass: "pb-1"
  }, [_c('v-container', {
    staticClass: "pa-0",
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "text-xs-center white--text",
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "primary lighten-1 pa-1"
  }, [_c('strong', [_vm._v(_vm._s(_vm.lComp.cust_name + ' (' + (_vm.lComp.is_behalf ? (_vm.lComp.role_name + (_vm.lComp.block_nm ? (' on behalf of ' + _vm.lComp.block_nm + ',' + _vm.lComp.unit_no) : '')) : (_vm.lComp.block_nm + ',' + _vm.lComp.unit_no)) + ')'))])]), _vm._v(" "), _c('div', {
    staticClass: "primary lighten-2 pa-1"
  }, [_vm._v("\n                " + _vm._s(_vm.lComp.comp_title) + "\n              ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("Was sent to ")]), _c('br'), _vm._v(_vm._s(_vm.lComp.comp_to_list && _vm.lComp.comp_to_list.join()) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('span', {
    staticClass: "caption grey--text"
  }, [_vm._v("Preferred date & time ")]), _c('br'), _vm._v(_vm._s(_vm.lComp.pref_attend_dt_time_text) + "\n            ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "label": "Category",
      "items": _vm.cats,
      "item-text": "comp_cat",
      "item-value": "comp_cat_id",
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.comp_cat_pair),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_cat_pair", $$v)
      },
      expression: "lComp.comp_cat_pair"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Severity",
      "items": ['Normal', 'Major', 'Critical'],
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.comp_severity),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_severity", $$v)
      },
      expression: "lComp.comp_severity"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-alert', {
    staticClass: "pa-3",
    attrs: {
      "color": "warning lighten-1",
      "value": "true"
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Status",
      "items": _vm.statusList,
      "rules": [_vm.rules.required],
      "hide-details": ""
    },
    model: {
      value: (_vm.lComp.comp_status),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "comp_status", $$v)
      },
      expression: "lComp.comp_status"
    }
  }), _vm._v(" "), _c('v-combobox', {
    attrs: {
      "label": "Assigned to",
      "items": _vm.mcList,
      "item-text": "user_name",
      "item-value": "user_id"
    },
    on: {
      "input": function($event) {
        _vm.lComp.comp_status === 'New' ? _vm.lComp.comp_status = 'Assigned' : _vm.lComp.comp_status
      }
    },
    model: {
      value: (_vm.lComp.assigned_to_pair),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "assigned_to_pair", $$v)
      },
      expression: "lComp.assigned_to_pair"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "outline": "",
      "hide-details": "",
      "label": "Notes/Resolution",
      "rows": "2"
    },
    model: {
      value: (_vm.lComp.notes),
      callback: function($$v) {
        _vm.$set(_vm.lComp, "notes", $$v)
      },
      expression: "lComp.notes"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('input', {
    ref: "resolveFileInput",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": "image/*",
      "multiple": ""
    },
    on: {
      "change": function($event) {
        return _vm.loadFilesFromFileBrowser(_vm.lComp)
      }
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "ma-0",
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), (_vm.lComp.files && _vm.lComp.files.filter(function (rec) { return rec.is_selected && rec.source_type === 'Resolve'; }).length > 0) ? _c('span', _vm._l((_vm.lComp.files.filter(function (rec) { return rec.source_type === 'Resolve'; })), function(file, index) {
    return _c('span', {
      key: index
    }, [_c('v-chip', {
      attrs: {
        "close": ""
      },
      model: {
        value: (file.is_selected),
        callback: function($$v) {
          _vm.$set(file, "is_selected", $$v)
        },
        expression: "file.is_selected"
      }
    }, [_vm._v(_vm._s(file.file_name))])], 1)
  }), 0) : _c('span', [_vm._v("Attachment if any"), _c('span', {
    staticClass: "caption"
  }, [_vm._v(" (images only, upto 20MB)")])])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "pt-0"
  }, [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.cancelChangesResol($event)
      }
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "type": "submit",
      "color": "accent",
      "disabled": _vm.beingSaved
    }
  }, [_vm._v("Save")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "max-width": "500px",
      "persistent": "",
      "scrollable": ""
    },
    model: {
      value: (_vm.showRateCard),
      callback: function($$v) {
        _vm.showRateCard = $$v
      },
      expression: "showRateCard"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4"
  }, [_c('span', [_vm._v("Rate (On-call Services)")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    nativeOn: {
      "click": function($event) {
        _vm.showRateCard = false, _vm.search = ''
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "pa-0"
  }, [_c('v-data-table', {
    attrs: {
      "headers": _vm.rateHead,
      "items": _vm.rateCard,
      "hide-actions": "",
      "search": _vm.search
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('tr', [_c('td', [_vm._v(_vm._s(props.item.service_name))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.uom))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.handy.formatCur(props.item.price)))])])]
      }
    }])
  })], 1), _vm._v(" "), _c('v-card-actions', {
    staticClass: "grey lighten-4 caption"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    staticClass: "pa-0 ml-1",
    attrs: {
      "append-icon": "search",
      "hide-details": "",
      "placeholder": "Search",
      "clearable": ""
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-download-as', {
    attrs: {
      "title": "Rate Card (On-call Services)",
      "headers": _vm.rateHead,
      "items": _vm.rateCard
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "scrollable": "",
      "persistent": "",
      "max-width": "450px"
    },
    model: {
      value: (_vm.showRating),
      callback: function($$v) {
        _vm.showRating = $$v
      },
      expression: "showRating"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "title grey lighten-4 py-0 pr-0"
  }, [_vm._v("\n      Feedback\n      "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancelRating
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Overall satisfaction")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs5": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "20",
      "color": "accent",
      "background-color": "grey",
      "readonly": !_vm.rComp.is_related_user,
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveRatings(_vm.rComp, false)
      }
    },
    model: {
      value: (_vm.rComp.overall),
      callback: function($$v) {
        _vm.$set(_vm.rComp, "overall", $$v)
      },
      expression: "rComp.overall"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Quality of work")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs5": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "20",
      "color": "accent",
      "background-color": "grey",
      "readonly": !_vm.rComp.is_related_user,
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveRatings(_vm.rComp, false)
      }
    },
    model: {
      value: (_vm.rComp.quality),
      callback: function($$v) {
        _vm.$set(_vm.rComp, "quality", $$v)
      },
      expression: "rComp.quality"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Technician had proper tools")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs5": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "20",
      "color": "accent",
      "background-color": "grey",
      "readonly": !_vm.rComp.is_related_user,
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveRatings(_vm.rComp, false)
      }
    },
    model: {
      value: (_vm.rComp.tools),
      callback: function($$v) {
        _vm.$set(_vm.rComp, "tools", $$v)
      },
      expression: "rComp.tools"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs7": "",
      "md6": ""
    }
  }, [_c('div', [_vm._v("Friendliness of technician")])]), _vm._v(" "), _c('v-flex', {
    staticClass: "text-xs-right",
    attrs: {
      "xs5": "",
      "md6": ""
    }
  }, [_c('v-rating', {
    attrs: {
      "size": "20",
      "color": "accent",
      "background-color": "grey",
      "readonly": !_vm.rComp.is_related_user,
      "dense": ""
    },
    on: {
      "input": function($event) {
        return _vm.saveRatings(_vm.rComp, false)
      }
    },
    model: {
      value: (_vm.rComp.friendliness),
      callback: function($$v) {
        _vm.$set(_vm.rComp, "friendliness", $$v)
      },
      expression: "rComp.friendliness"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider', {
    staticClass: "my-2"
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Any other feedback (optional)",
      "hide-actions": "",
      "rows": "2",
      "maxlength": "100",
      "disabled": !_vm.rComp.is_related_user
    },
    on: {
      "change": function($event) {
        return _vm.saveRatings(_vm.rComp, false)
      }
    },
    model: {
      value: (_vm.rComp.other_feedback),
      callback: function($$v) {
        _vm.$set(_vm.rComp, "other_feedback", $$v)
      },
      expression: "rComp.other_feedback"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "color": _vm.sbarCol,
      "timeout": 3000,
      "multi-line": ""
    },
    model: {
      value: (_vm.sbar),
      callback: function($$v) {
        _vm.sbar = $$v
      },
      expression: "sbar"
    }
  }, [_c('span', {
    staticClass: "mx-auto"
  }, [_vm._v(_vm._s(_vm.sbarMsg))])]), _vm._v(" "), (_vm.load) ? _c('div', {
    staticClass: "text-xs-center mt-5"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/template-compiler?{"id":"data-v-378f085a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!C:/Users/vijay/L180/prototypes/uni-uswebapp/~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Complaints.vue
// module id = 848
// module chunks = 2